import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'cart-abandoned_brand_cart_nudge_dismissed-dismiss';
/**
 * User dismisses the abandoned brand cart nudge modal on Web
 */
export function trackCartAbandonedBrandCartNudgeDismissedDismiss(NudgeType_string, PageName_string2, manualOverrides) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: true,
        manualOverrides: manualOverrides,
        parameters: { NudgeType_string, PageName_string2 },
    });
}
